// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"707e4348","732":"36e1fcd8","977":"0296ef2c"}[chunkId] + ".chunk.js";
};